import { Category } from 'shared/types/product';

// Storefront fixes for categories until the catalog catches up, keyed by storefront URL. `null`
// hides a category (Traditional Wood Handrail's listing is broken); a string relabels it in the nav,
// breadcrumbs and listing heading.
// TODO(catalog): rename/unpublish these in commercetools so the overrides can go away.
const CATEGORY_LABELS: Record<string, string | null> = {
  '/handrail/traditional-wood-handrail': null,
  '/handrail/modern-wood-handrail': 'Wood Handrail',
};

const urlKey = (url?: string) => (url ?? '').replace(/\/$/, '');

export const categoryLabelOverride = (url?: string) => CATEGORY_LABELS[urlKey(url)];

export const isHiddenCategory = (category: Pick<Category, '_url'>) => categoryLabelOverride(category._url) === null;


/**
 * The category list with every override applied: hidden categories (and their subtrees) dropped,
 * relabelled ones renamed. Applied once where categories are fetched, so every consumer of the
 * tree — nav, listings, breadcrumbs, home tiles — gets the same view.
 */
export const applyCategoryOverrides = <T extends Category>(categories: T[]): T[] =>
  categories
    .filter((category) => !isHiddenCategory(category))
    .map((category) => {
      const label = categoryLabelOverride(category._url);
      const descendants = category.descendants && applyCategoryOverrides(category.descendants);
      return { ...category, ...(label && { name: label }), ...(descendants && { descendants }) };
    });

/**
 * Wood Post Cable Railing: the nav and breadcrumb home for every DriveTite product (wood-post cable
 * hardware and install tools), which the catalog splits across an Express and a Signature category.
 * Links the Signature DriveTite listing until a dedicated category exists.
 * TODO(catalog): point at the "Wood Post Cable Railing" category once it is created in commercetools.
 */
export const WOOD_POST_CABLE_RAILING = {
  label: 'Wood Post Cable Railing',
  href: '/railing/signature-cable-railing/drivetite-wood-components/',
};
const WOOD_POST_CABLE_CATEGORY_URLS = [
  '/railing/signature-cable-railing/drivetite-wood-components',
  '/railing/express-cable-railing/express-drivetite-wood-components',
];
export const isWoodPostCableCategory = (url?: string) => WOOD_POST_CABLE_CATEGORY_URLS.includes(urlKey(url));
